// Mock dataset for DEMO mode. Shapes mirror the columns the pages read from
// hr.v_employee_summary, hr.warnings, hr.performance_notes.

export const DEMO_USER = {
  id: 'demo-user',
  role: 'admin',
  employee_id: 'e2',
  branch_scope: [],
};

// "ของฉัน" shows the signed-in person's own profile. In demo, the person trying it
// is Saii (a ผู้จัดการ) → e2; switch to staff to preview a regular employee (Ice/e1).
export const DEMO_EMP_BY_ROLE = { manager: 'e2', admin: 'e2', staff: 'e1' };

const employees = [
  {
    id: 'e1', emp_code: 'E001', nickname: 'Ice', first_name: 'ไอซ์', last_name: 'เย็นจิต',
    status: 'active', branch: 'สาขาเซ็นทรัล', position: 'พนักงานขาย',
    start_date: '2024-02-01', tenure_days: 872,
    active_warnings: 1, late_count_ytd: 3, absent_count_ytd: 0,
  },
  {
    id: 'e2', emp_code: 'E002', nickname: 'Saii', first_name: 'สายใจ', last_name: 'มั่นคง',
    status: 'active', branch: 'สาขาเซ็นทรัล', position: 'ผู้จัดการ',
    start_date: '2023-08-15', tenure_days: 1042,
    active_warnings: 0, late_count_ytd: 0, absent_count_ytd: 0,
  },
  {
    id: 'e3', emp_code: 'E003', nickname: 'Tongz', first_name: 'ต้องการ', last_name: 'มากมี',
    status: 'active', branch: 'สาขาลาดพร้าว', position: 'สต๊อก',
    start_date: '2022-05-01', tenure_days: 1513,
    active_warnings: 2, late_count_ytd: 6, absent_count_ytd: 1,
  },
  {
    id: 'e4', emp_code: 'E004', nickname: 'Ake', first_name: 'เอก', last_name: 'ผู้นำ',
    status: 'active', branch: 'สาขาเซ็นทรัล', position: 'หัวหน้าสาขา',
    start_date: '2020-01-10', tenure_days: 2355,
    active_warnings: 0, late_count_ytd: 0, absent_count_ytd: 0,
  },
  {
    id: 'e5', emp_code: 'E005', nickname: 'fk', first_name: 'เอฟ', last_name: 'เค',
    status: 'probation', branch: 'สาขาลาดพร้าว', position: 'พนักงานขาย',
    start_date: '2026-04-20', tenure_days: 63,
    active_warnings: 0, late_count_ytd: 2, absent_count_ytd: 0,
  },
  {
    id: 'e6', emp_code: 'E006', nickname: 'Milk', first_name: 'มิลค์', last_name: 'สดใส',
    status: 'active', branch: 'สาขาเซ็นทรัล', position: 'พนักงานขาย',
    start_date: '2023-11-01', tenure_days: 965,
    active_warnings: 0, late_count_ytd: 0, absent_count_ytd: 0,
  },
];

const warnings = {
  e1: [
    {
      id: 'w1', employee_id: 'e1', category: 'attendance', ladder_level: 2, level_name: 'written',
      policy_clause: 'ข้อ 7.3 — การมาทำงานสาย', incident_date: '2026-05-26', expires_at: '2027-05-26',
      status: 'active', ack_status: 'pending', acknowledged_at: null, issued_by_name: 'ผู้จัดการ Saii',
      incident_detail: 'มาทำงานสายเกินกำหนด 35 นาที โดยไม่แจ้งล่วงหน้า เป็นครั้งที่ 3 ในเดือนนี้',
    },
  ],
  e3: [
    {
      id: 'w2', employee_id: 'e3', category: 'attendance', ladder_level: 3, level_name: 'final',
      policy_clause: 'ข้อ 7.1 — การขาดงานโดยไม่แจ้ง', incident_date: '2026-03-12', expires_at: '2027-03-12',
      status: 'active', ack_status: 'acknowledged', acknowledged_at: '2026-03-13', issued_by_name: 'หัวหน้า Ake',
      incident_detail: 'ขาดงานโดยไม่แจ้งล่วงหน้า 1 วัน ทำให้สาขาขาดกำลังคน',
    },
    {
      id: 'w3', employee_id: 'e3', category: 'safety', ladder_level: 1, level_name: 'verbal',
      policy_clause: 'ข้อ 11.4 — ความปลอดภัยในการทำงาน', incident_date: '2026-06-01', expires_at: '2027-06-01',
      status: 'active', ack_status: 'pending', acknowledged_at: null, issued_by_name: 'หัวหน้า Ake',
      incident_detail: 'ไม่สวมอุปกรณ์ความปลอดภัยขณะยกของหนักในคลัง',
    },
  ],
};

const notes = {
  e1: [
    { id: 'n1', note_type: 'positive', title: 'ปิดการขายลูกค้ารายใหญ่', occurred_on: '2026-06-12' },
    { id: 'n2', note_type: 'negative', title: 'ลืมล็อกตู้สินค้า', occurred_on: '2026-06-03' },
  ],
  e3: [
    { id: 'n3', note_type: 'neutral', title: 'ย้ายไปช่วยสาขาเซ็นทรัลชั่วคราว', occurred_on: '2026-05-20' },
  ],
};

// ใบชมเชย / ผลงานดี (mutable — "ออกใบชมเชย" ในโหมด demo จะ push เข้ามาที่นี่)
const commendations = {
  e1: [
    { id: 'c1', category: 'performance', title: 'ปิดการขายลูกค้ารายใหญ่', detail: 'ปิดดีลมูลค่าสูงด้วยตัวเอง', reward_points: 20, occurred_on: '2026-06-12' },
  ],
  e2: [
    { id: 'c2', category: 'service', title: 'ลูกค้าเขียนชมการบริการ', detail: 'ดูแลลูกค้าอย่างดีจนได้รีวิว 5 ดาว', reward_points: 10, occurred_on: '2026-06-05' },
  ],
  e4: [
    { id: 'c3', category: 'teamwork', title: 'ช่วยทีมข้ามสาขาช่วงคนขาด', detail: 'อาสาช่วยสาขาลาดพร้าวช่วงขาดกำลังคน', reward_points: 30, occurred_on: '2026-05-15' },
  ],
};

// Attendance flags as if synced from HR TimeTrack (public.hr_logs → hr.attendance_flags).
// is_excused=true means the day matched an approved leave → NOT counted as a fault.
const attendance = {
  e1: [
    { id: 'a1', work_date: '2026-06-18', flag_type: 'late', minutes: 35, is_excused: false },
    { id: 'a2', work_date: '2026-06-11', flag_type: 'late', minutes: 20, is_excused: false },
    { id: 'a3', work_date: '2026-05-29', flag_type: 'late', minutes: 16, is_excused: false },
    { id: 'a4', work_date: '2026-05-20', flag_type: 'absent', minutes: 0, is_excused: true, leave_label: 'ลาป่วย (มีใบรับรองแพทย์)' },
  ],
  e3: [
    { id: 'a5', work_date: '2026-06-15', flag_type: 'absent', minutes: 0, is_excused: false },
    { id: 'a6', work_date: '2026-06-09', flag_type: 'late', minutes: 42, is_excused: false },
    { id: 'a7', work_date: '2026-06-02', flag_type: 'early_leave', minutes: 30, is_excused: false },
    { id: 'a8', work_date: '2026-05-28', flag_type: 'late', minutes: 18, is_excused: false },
  ],
};

// ประเภทการลา (ย่อจาก seed ใน hr_schema.sql รวม พ.ร.บ.9/2568)
const leaveTypes = [
  { id: 'lt_sick', code: 'sick', name_th: 'ลาป่วย', requires_medical_cert: false, note: 'ลา ≥3 วันต้องมีใบรับรองแพทย์' },
  { id: 'lt_personal', code: 'personal', name_th: 'ลากิจธุระจำเป็น', requires_medical_cert: false, note: '' },
  { id: 'lt_vacation', code: 'vacation', name_th: 'ลาพักร้อน', requires_medical_cert: false, note: 'ครบ 1 ปีจึงมีสิทธิ' },
  { id: 'lt_maternity', code: 'maternity', name_th: 'ลาคลอด', requires_medical_cert: false, note: 'พ.ร.บ.9/2568 · 120 วัน/ครรภ์' },
  { id: 'lt_spouse', code: 'spouse_birth', name_th: 'ลาช่วยเหลือคู่สมรสคลอด', requires_medical_cert: false, note: 'พ.ร.บ.9/2568 · ภายใน 90 วันนับแต่คลอด' },
];

// ยอดสิทธิคงเหลือต่อคน/ปี
const leaveBalances = {
  e1: { sick: { entitled: 30, used: 1 }, personal: { entitled: 3, used: 0 }, vacation: { entitled: 6, used: 1 } },
  e2: { sick: { entitled: 30, used: 0 }, personal: { entitled: 3, used: 1 }, vacation: { entitled: 6, used: 2 } },
  e3: { sick: { entitled: 30, used: 2 }, personal: { entitled: 3, used: 0 }, vacation: { entitled: 6, used: 4 } },
  e4: { sick: { entitled: 30, used: 0 }, personal: { entitled: 3, used: 0 }, vacation: { entitled: 6, used: 0 } },
  e5: { sick: { entitled: 30, used: 0 }, personal: { entitled: 3, used: 0 }, vacation: { entitled: 6, used: 0 } },
  e6: { sick: { entitled: 30, used: 0 }, personal: { entitled: 3, used: 0 }, vacation: { entitled: 6, used: 1 } },
};

// ใบลา — รวมทั้ง approved (สิทธิในสถิติ) และ pending (คิวรออนุมัติ)
const leaves = {
  e1: [
    { id: 'l1', code: 'sick', name_th: 'ลาป่วย', start_date: '2026-05-20', end_date: '2026-05-20', days: 1, status: 'approved' },
    { id: 'l2', code: 'vacation', name_th: 'ลาพักร้อน', start_date: '2026-06-05', end_date: '2026-06-05', days: 1, status: 'approved' },
  ],
  e6: [
    { id: 'l4', code: 'sick', name_th: 'ลาป่วย', start_date: '2026-06-25', end_date: '2026-06-26', days: 2, status: 'pending', reason: 'เป็นไข้หวัด', medical_cert: true },
  ],
  e3: [
    { id: 'l3', code: 'personal', name_th: 'ลากิจธุระจำเป็น', start_date: '2026-06-23', end_date: '2026-06-23', days: 1, status: 'approved' },
    { id: 'l5', code: 'vacation', name_th: 'ลาพักร้อน', start_date: '2026-07-01', end_date: '2026-07-02', days: 2, status: 'pending', reason: 'พาครอบครัวเที่ยว' },
    { id: 'l7', code: 'personal', name_th: 'ลากิจธุระจำเป็น', start_date: '2026-06-15', end_date: '2026-06-15', days: 1, status: 'pending', reason: 'ธุระครอบครัว (แจ้งย้อนหลัง) — วันที่เคยขาด' },
  ],
  e5: [
    { id: 'l6', code: 'spouse_birth', name_th: 'ลาช่วยเหลือคู่สมรสคลอด', start_date: '2026-07-05', end_date: '2026-07-19', days: 15, status: 'pending', reason: 'คู่สมรสคลอดบุตร' },
  ],
};
const inMonth = (d, ym) => (d || '').slice(0, 7) === ym;
const empName = (id) => { const e = employees.find((x) => x.id === id); return e ? (e.nickname || e.first_name) : id; };

// งาน compliance ประจำปี (คร.11 + PDPA) — เตือนบน dashboard เมื่อใกล้กำหนด
const compliance = [
  { id: 'cr_pdpa', type: 'pdpa', title: 'ทบทวนประกาศความเป็นส่วนตัว + เก็บ consent พนักงาน', due_date: '2026-08-31', status: 'pending' },
  { id: 'cr_kor11', type: 'kor11', title: 'ยื่นแบบ คร.11 สภาพการจ้าง (ลูกจ้าง ≥10 คน)', due_date: '2027-01-31', status: 'pending' },
];

// ข้อบังคับเกี่ยวกับการทำงาน (ที่ยื่นแล้ว) — ใบเตือนต้องอ้างข้อจริง
const policyClauses = [
  { id: 'pc1', clause_no: 'ข้อ 7.3', category: 'attendance', title: 'การมาทำงานสาย' },
  { id: 'pc2', clause_no: 'ข้อ 7.1', category: 'attendance', title: 'การขาดงานโดยไม่แจ้งล่วงหน้า' },
  { id: 'pc3', clause_no: 'ข้อ 9.2', category: 'conduct', title: 'การดูแลรักษาทรัพย์สินบริษัท' },
  { id: 'pc4', clause_no: 'ข้อ 11.4', category: 'safety', title: 'ความปลอดภัยในการทำงาน' },
];
const LEVEL_NAME = { 1: 'verbal', 2: 'written', 3: 'final', 4: 'terminate' };
const addYear = (d) => { const [y, m, day] = d.split('-'); return `${+y + 1}-${m}-${day}`; };

// ===== Phase 3: KPI & Evaluation =====
// KPI ต่อตำแหน่ง (น้ำหนักรวม 100) — ประเมินให้คะแนน 0–100 ต่อข้อ
const kpiDefs = {
  'พนักงานขาย': [{ id: 'k1', name: 'ยอดขายเทียบเป้า', weight: 40 }, { id: 'k2', name: 'บริการลูกค้า', weight: 30 }, { id: 'k3', name: 'การเข้างาน/วินัย', weight: 30 }],
  'แคชเชียร์': [{ id: 'k4', name: 'ความแม่นยำเงินสด', weight: 40 }, { id: 'k5', name: 'ความเร็วบริการ', weight: 30 }, { id: 'k6', name: 'การเข้างาน/วินัย', weight: 30 }],
  'สต๊อก': [{ id: 'k7', name: 'ความแม่นยำสต๊อก', weight: 40 }, { id: 'k8', name: 'ความเร็วจัดของ', weight: 30 }, { id: 'k9', name: 'การเข้างาน/วินัย', weight: 30 }],
  'หัวหน้าสาขา': [{ id: 'k10', name: 'ยอดขายสาขา', weight: 40 }, { id: 'k11', name: 'การบริหารทีม', weight: 35 }, { id: 'k12', name: 'การเข้างาน/วินัย', weight: 25 }],
};
const defaultKpis = [{ id: 'kd1', name: 'คุณภาพงาน', weight: 50 }, { id: 'kd2', name: 'การเข้างาน/วินัย', weight: 50 }];
const kpisFor = (pos) => kpiDefs[pos] || defaultKpis;
const calcOverall = (scores, kpis) => {
  const tw = kpis.reduce((a, k) => a + k.weight, 0);
  const s = kpis.reduce((a, k) => a + (Number(scores[k.id]) || 0) * k.weight, 0);
  return tw ? Math.round(s / tw) : 0;
};

const evalCycle = { id: 'cyc1', name: 'รอบครึ่งปีแรก 2569', period_start: '2026-01-01', period_end: '2026-06-30', status: 'open', announced_at: '2025-12-20' };

// evaluations ต่อพนักงาน (mutable) — draft → submitted → acknowledged
const evaluations = {
  e1: { employee_id: 'e1', scores: { k1: 85, k2: 88, k3: 80 }, overall_score: 84, strengths: 'ปิดการขายลูกค้ารายใหญ่ได้ดี เข้าใจสินค้า', improvements: 'ความตรงต่อเวลายังต้องปรับ', status: 'submitted', acknowledged_at: null },
  e2: { employee_id: 'e2', scores: { k4: 85, k5: 80, k6: 82 }, overall_score: 83, strengths: 'บริการลูกค้าได้รับคำชม', improvements: 'เพิ่มความเร็วช่วงพีค', status: 'acknowledged', acknowledged_at: '2026-06-18' },
  e4: { employee_id: 'e4', scores: { k10: 90, k11: 88, k12: 85 }, overall_score: 88, strengths: 'นำทีมดี ยอดสาขาโต', improvements: 'มอบหมายงานให้ลูกทีมมากขึ้น', status: 'submitted', acknowledged_at: null },
};

// ===== Phase 4: Decision Support =====
const baseSalaries = { e1: 18000, e2: 28000, e3: 15000, e4: 32000, e5: 15000, e6: 18000 };

// ข้อเสนอ (system แนะนำจาก eval+notes+attendance) — มนุษย์ตัดสิน
const recommendations = {
  e4: { id: 'rc1', employee_id: 'e4', type: 'promotion', basis: 'คะแนนประเมิน 88 · นำทีมดี ยอดสาขาโต · ไม่มีใบเตือน', suggested_value: 3000, status: 'pending' },
  e1: { id: 'rc2', employee_id: 'e1', type: 'bonus', basis: 'คะแนน 84 · มีใบชมเชย แต่มาสาย 3 ครั้ง', suggested_value: 5000, status: 'pending' },
  e2: { id: 'rc3', employee_id: 'e2', type: 'salary_increase', basis: 'คะแนน 83 · บริการลูกค้าได้รับคำชม', suggested_value: 1500, status: 'pending' },
};

let seq = 100;

// Simulate a little network latency so loading states are visible.
const delay = (v) => new Promise((r) => setTimeout(() => r(v), 180));

// Derive commendation_count + reward_points from the (mutable) store.
function enrich(emp) {
  const cs = commendations[emp.id] ?? [];
  return {
    ...emp,
    commendation_count: cs.length,
    reward_points: cs.reduce((a, c) => a + (c.reward_points || 0), 0),
  };
}

export const demoApi = {
  listSummaries: () => delay(employees.map(enrich)),
  getSummary: (id) => { const e = employees.find((x) => x.id === id); return delay(e ? enrich(e) : null); },
  getWarnings: (empId) => delay(warnings[empId] ?? []),
  getAttendance: (empId) => delay([...(attendance[empId] ?? [])].sort((a, b) => (a.work_date < b.work_date ? 1 : -1))),
  getAttendanceMonth: (empId, ym) =>
    delay((attendance[empId] ?? []).filter((a) => inMonth(a.work_date, ym)).sort((a, b) => (a.work_date < b.work_date ? 1 : -1))),
  getLeaveMonth: (empId, ym) =>
    delay((leaves[empId] ?? []).filter((l) => l.status === 'approved' && (inMonth(l.start_date, ym) || inMonth(l.end_date, ym)))),
  getComplianceReminders: () => delay(compliance.filter((c) => c.status === 'pending')),
  // ---- decision support (Phase 4) ----
  getEmploymentInfo: (empId) => delay({ base_salary: baseSalaries[empId] ?? null }),
  listRecommendations: () => delay(
    Object.values(recommendations).map((r) => {
      const e = employees.find((x) => x.id === r.employee_id);
      return { ...r, emp_name: e ? (e.nickname || e.first_name) : r.employee_id, position: e?.position };
    }).sort((a, b) => (a.status === 'pending' ? -1 : 1))
  ),
  decideRecommendation: (id, decision) => {
    const r = Object.values(recommendations).find((x) => x.id === id);
    if (r) r.status = decision;
    return delay(r ? { ...r } : null);
  },
  // ---- evaluations (Phase 3) ----
  getCurrentCycle: () => delay({ ...evalCycle }),
  getKpis: (position) => delay([...kpisFor(position)]),
  listEvaluations: () => delay(employees.map((e) => {
    const ev = evaluations[e.id];
    return { employee_id: e.id, emp_name: e.nickname || e.first_name, position: e.position,
      status: ev?.status || 'not_started', overall_score: ev?.overall_score ?? null };
  })),
  getEvaluation: (empId) => delay(evaluations[empId] ? { ...evaluations[empId] } : null),
  saveEvaluation: ({ employee_id, position, scores, strengths, improvements, status }) => {
    const overall = calcOverall(scores, kpisFor(position));
    const rec = { employee_id, scores: { ...scores }, overall_score: overall,
      strengths: strengths || '', improvements: improvements || '',
      status: status || 'draft', acknowledged_at: evaluations[employee_id]?.acknowledged_at || null };
    evaluations[employee_id] = rec;
    return delay({ ...rec });
  },
  acknowledgeEvaluation: (empId) => {
    const ev = evaluations[empId];
    if (ev) { ev.status = 'acknowledged'; ev.acknowledged_at = new Date().toISOString().slice(0, 10); }
    return delay(ev ? { ...ev } : null);
  },
  listLeaveTypes: () => delay([...leaveTypes]),
  getLeaveBalances: (empId) => {
    const b = leaveBalances[empId] || {};
    return delay(leaveTypes.filter((t) => b[t.code]).map((t) => ({
      code: t.code, name_th: t.name_th, entitled: b[t.code].entitled, used: b[t.code].used,
      remaining: b[t.code].entitled - b[t.code].used,
    })));
  },
  getMyLeaves: (empId) => delay([...(leaves[empId] ?? [])].sort((a, b) => (a.start_date < b.start_date ? 1 : -1))),
  listPendingLeaves: () => delay(
    Object.entries(leaves).flatMap(([eid, arr]) =>
      arr.filter((l) => l.status === 'pending').map((l) => ({ ...l, employee_id: eid, emp_name: empName(eid) }))
    ).sort((a, b) => (a.start_date < b.start_date ? 1 : -1))
  ),
  requestLeave: ({ employee_id, code, name_th, start_date, end_date, days, reason, medical_cert }) => {
    const rec = { id: `l${++seq}`, code, name_th, start_date, end_date, days: Number(days) || 1,
      reason: reason || '', medical_cert: !!medical_cert, status: 'pending' };
    (leaves[employee_id] ||= []).unshift(rec);
    return delay(rec);
  },
  decideLeave: (id, approve) => {
    let updated = null;
    for (const [eid, arr] of Object.entries(leaves)) {
      const l = arr.find((x) => x.id === id);
      if (l) {
        l.status = approve ? 'approved' : 'rejected';
        if (approve) {
          if (leaveBalances[eid]?.[l.code]) leaveBalances[eid][l.code].used += l.days;
          // end-to-end: วันที่อนุมัติลา → flag เข้างานวันนั้นกลายเป็น "ไม่นับเป็นความผิด"
          (attendance[eid] || []).forEach((f) => {
            if (f.work_date >= l.start_date && f.work_date <= l.end_date) {
              f.is_excused = true;
              f.leave_label = l.name_th;
            }
          });
        }
        updated = l;
        break;
      }
    }
    return delay(updated);
  },
  getWarning: (id) => delay(Object.values(warnings).flat().find((w) => w.id === id) ?? null),
  listPolicyClauses: () => delay([...policyClauses]),
  // เสนอขั้น ladder อัตโนมัติ: ขั้นสูงสุดของหมวดนี้ที่ยัง active + 1 (สูงสุด 4)
  suggestLadder: (empId, category) => {
    const prior = (warnings[empId] ?? []).filter((w) => w.category === category && w.status === 'active');
    const maxLvl = prior.reduce((m, w) => Math.max(m, w.ladder_level || 0), 0);
    return delay({ level: Math.min(4, maxLvl + 1), prior_count: prior.length });
  },
  issueWarning: ({ employee_id, category, ladder_level, policy_clause, incident_date, incident_detail, issued_by_name }) => {
    const rec = {
      id: `w${++seq}`, employee_id, category, ladder_level,
      level_name: LEVEL_NAME[ladder_level] || 'verbal', policy_clause,
      incident_date, expires_at: addYear(incident_date), status: 'active',
      ack_status: 'pending', acknowledged_at: null,
      issued_by_name: issued_by_name || 'หัวหน้า', incident_detail,
    };
    (warnings[employee_id] ||= []).unshift(rec);
    return delay(rec);
  },
  issueLearningPoint: ({ employee_id, topic, detail, follow_up_date }) => {
    const rec = { id: `lp${++seq}`, employee_id, topic, detail: detail || '', follow_up_date: follow_up_date || null,
      occurred_on: new Date().toISOString().slice(0, 10) };
    // โผล่ในไทม์ไลน์ "บันทึกล่าสุด" ฝั่ง neutral
    (notes[employee_id] ||= []).unshift({ id: rec.id, note_type: 'neutral', title: `Learning point: ${topic}`, occurred_on: rec.occurred_on });
    return delay(rec);
  },
  acknowledgeWarning: (id, { refuse, witness } = {}) => {
    const w = Object.values(warnings).flat().find((x) => x.id === id);
    if (w) {
      w.ack_status = refuse ? 'refused_with_witness' : 'acknowledged';
      w.acknowledged_at = new Date().toISOString().slice(0, 10);
      if (refuse) w.witness_name = witness || '';
    }
    return delay(w);
  },
  getNotes: (empId) => delay(notes[empId] ?? []),
  getCommendations: (empId) =>
    delay([...(commendations[empId] ?? [])].sort((a, b) => (a.occurred_on < b.occurred_on ? 1 : -1))),
  issueCommendation: ({ employee_id, category, title, detail, reward_points, occurred_on }) => {
    const rec = {
      id: `c${++seq}`, category: category || 'performance', title,
      detail: detail || '', reward_points: Number(reward_points) || 0,
      occurred_on: occurred_on || new Date().toISOString().slice(0, 10),
    };
    (commendations[employee_id] ||= []).unshift(rec);
    return delay(rec);
  },
};
